<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Hold Balance Details" :breadcrumb="breadcrumb"/>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
<!--          <div class="m-1">-->
<!--            <div class="row">-->
<!--              <div class="col-md-6 col-6">-->
<!--                <div class="d-flex mt-sm-1 ">-->
<!--                  <button-->
<!--                      type="button"-->
<!--                      class="btn btn-gradient-danger"-->
<!--                      @click="$router.push({ name: 'overview' })"-->
<!--                  >-->
<!--                    <span class="text-nowrap">Back</span>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
<!--&lt;!&ndash;              <div class="col-md-6 col-6">&ndash;&gt;-->
<!--&lt;!&ndash;                <div class="d-flex  justify-content-end">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="form-group">&ndash;&gt;-->
<!--&lt;!&ndash;                    <label class="form-label">Currency</label>&ndash;&gt;-->
<!--&lt;!&ndash;                    <select class="form-control" v-model="selectdValet">&ndash;&gt;-->
<!--&lt;!&ndash;                      <option :key="valetIndex" :value="valet" v-for="(valet, valetIndex) in valetData">&ndash;&gt;-->
<!--&lt;!&ndash;                        {{ valet.currency.code }}&ndash;&gt;-->
<!--&lt;!&ndash;                      </option>&ndash;&gt;-->
<!--&lt;!&ndash;                    </select>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
          <CommonTable
              v-if="accountId" :key="accountId"
              url="v1/get-balance-on-hold"
              :tableHeaderValues="tableHeaderValues"
              :filteredData="filteredData"
              :actions="actions"
              :mutedData="[]"
              customClass="table-hover-animation"
              :loadMore="true"
              :hidePerPage="true"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

import {mapState} from "vuex";

export default {
  computed: {
    ...mapState(['walletAccount'])
  },
  mounted() {
    if (this.walletAccount) {
      this.selectdValet = this.walletAccount
      if(this.selectdValet){
        this.accountId = this.selectdValet.id
        this.filteredData = {userAccountId : this.accountId }

      }
    }
    // this.getValetData()
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Balance On Hold'},
      ],
      accountId: null,
      selectdValet: null,
      valetData: [],
      filteredData:{userAccountId : this.accountId },
      url : '',
      tableHeaderValues: [
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter: (value) => {
            var html = ''
            if (value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value/100).toFixed(this.amountDecimalPlaces)}</span>`


            return html


          }
        },
        {
          title: 'Total Amount',
          valueKey: 'total_amount',
          html: true,
          alter: (value) => {
            var html = ''
            if (value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value/100).toFixed(this.amountDecimalPlaces)}</span>`


            return html


          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value) => {
            var html = ''
            if (value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value/100).toFixed(this.feesDecimalPlaces)}</span>`


            return html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter: (value) => {
            var html = ''
            if (value)
              html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${parseFloat(value/100).toFixed(this.feesDecimalPlaces)}</span>`


            return html


          }
        },
        {
          title: 'Type',
          valueKey: 'type',
          html: true,
          alter: function (value) {
            var html = ''
            if (value == 1)
              html = ` <a href="javascript:void()" class="badge light badge-success ">Credit</a>`
            else
              html = ` <a href="javascript:void()" class="badge light badge-danger ">Debit</a>`

            return html


          }
        },
        {
          title: 'Transaction Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge light badge-light-primary ">${value}</a>`

            return html


          }
        },
        {
          title: 'Transaction Type Id',
          valueKey: 'type_id',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`

            return html


          }
        },
        {
          title: 'Currency',
          valueKey: 'user_account.currency.code',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-circle badge-light-success badge-glow">${value}</a>`

            return html


          }
        },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
       alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: []
    }
  },
  methods: {
    // getValetData() {
    //   this.makeRequest('post', 'v1/get-wallet-list', {}, {}, false).then(callResponse => {
    //     if (!callResponse.error) {
    //       let code = callResponse.response.data.code;
    //       let responseData = callResponse.response.data.data
    //       if (code == 200) {
    //         this.valetData = responseData
    //         this.$store.commit('setAccountData', responseData);
    //         this.setSelectValetValue()
    //
    //       }
    //     }
    //
    //   });
    // },
    // setSelectValetValue() {
    //   this.valetData.forEach((obj) => {
    //     if (obj.is_default == 1) {
    //       this.selectdValet = obj
    //       // this.accountId = obj.id
    //       // this.currency = obj
    //       this.$store.commit('setCurrencyData', obj);
    //       this.emitter.emit("change-currency", obj)
    //     }
    //   })
    //
    //   if (this.selectdValet == null && this.valetData.length > 0) {
    //     this.selectdValet = this.valetData[0]
    //     // this.currency = this.valetData[0]
    //     this.$store.commit('setCurrencyData', this.valetData[0]);
    //     this.emitter.emit("change-currency", this.valetData[0])
    //   }
    //
    // }
  },
  watch: {
    // selectdValet(val) {
    //   this.accountId = val.id
    //   this.filteredData={userAccountId : this.accountId }
    // }

    walletAccount(val) {

      this.selectdValet = val

      if(this.selectdValet){
        this.accountId = this.selectdValet.id
        this.filteredData={userAccountId : this.accountId }
      }

    },
  }
}
</script>

